import { createSelector } from "reselect"
import { initialState } from "./reducer"

/**
 * Direct selector to the importDivisionsContainer state domain
 */

const selectImportDivisionsContainerDomain = (state) =>
  state.get("importDivisionsContainer", initialState)

export const makeSelectPercentage = () =>
  createSelector(selectImportDivisionsContainerDomain, (state) =>
    state.get("percentage")
  )

export const makeSelectIsProcessingDivisions = () =>
  createSelector(selectImportDivisionsContainerDomain, (state) =>
    state.get("isProcessingDivisions")
  )

export const makeSelectImportedSummary = () =>
  createSelector(selectImportDivisionsContainerDomain, (state) =>
    state.get("importedSummary")
  )
/**
 * Other specific selectors
 */

/**
 * Default selector used by ImportDivisionsContainer
 */

const makeSelectImportDivisionsContainer = () =>
  createSelector(selectImportDivisionsContainerDomain, (substate) =>
    substate.toJS()
  )

export default makeSelectImportDivisionsContainer
export { selectImportDivisionsContainerDomain }
